<template>
    <v-navigation-drawer
      app
      fixed
      clipped
      :width="singleRoom ? '420' : '0'"
      v-show="singleRoom"
      :mini-variant.sync="mini"
      v-model="drawer"
      :mobile-breakpoint="roomId === undefined ? '0' : undefined"
      mini-variant-width="95"
      @input="$emit('set-drawer-state', drawer)"
      :style="`min-width: 95px;z-index: ${$vuetify.breakpoint.mobile ? 999 : 1}`"
    >
        <v-list-item>
          <v-btn block text v-if="roomId !== undefined" @click.stop="$vuetify.breakpoint.mobile ? (drawer=!drawer) : (mini=!mini)" class="d-flex justify-end">
            <v-icon v-if="!mini">mdi-chevron-left</v-icon>
            <v-icon v-else>mdi-chevron-right</v-icon>
          </v-btn>
          <!-- commented for prod, will be reused later, maybe -->
          <!-- <v-switch label="Switch mode (dev only)" v-model="singleRoom" class="ml-4"></v-switch> -->
        </v-list-item>
        <v-divider></v-divider>
        <v-card>
          <v-sheet
            class="pa-4"
            v-if="chatUser"
          >
            <v-row style="height: 90px">
              <v-col cols="20">
                <StatusAvatar class="ml-4" :user="getUser"/>
              </v-col>
              <v-col cols="20" v-show="!mini">
                <v-btn
                  v-show="chatsWrite"
                  data-testid="new-conversation-btn"
                  class="mb-6 ml-15"
                  fab
                  v-on:click="startConversation"
                >
                  <v-icon color="primary">
                    mdi-pencil
                  </v-icon>
                </v-btn>
              </v-col>
            </v-row>
            <div v-show="!mini" class="rocketUser">{{chatUser.name}} <small>x {{chatUser.extension}}</small></div>
            <div v-show="!mini"><small>{{$t('chat.as')}} {{chatUser.username}}</small></div>
          </v-sheet>

          <v-divider></v-divider>

          <v-expansion-panels focusable v-model="show.channels" accordion>
            <v-expansion-panel>
              <v-expansion-panel-header v-show="!mini">
                <v-badge
                  color="orange"
                  :value="unreadChannels"
                  offset-x="30"
                  offset-y="18"
                >
                  <span>{{ $t('chat.publicChannels') }}</span>
                  <span slot="badge"> {{ unreadChannels }} </span>
                </v-badge>
              </v-expansion-panel-header>
              <v-expansion-panel-content eager>
                <v-subheader>
                <v-list-item-content style="margin: 0px !important;min-width: 90px !important;">
                  <v-list-item-title>
                    <span class="mx-2" v-show="!mini">{{ $tc('chat.conversation', paginationChannels.total, { count: paginationChannels.total }) }}</span>
                  </v-list-item-title>
                </v-list-item-content>
                <v-list-item-action style="margin: 0px !important;">
                  <div class="d-flex justify-center">
                    <Search v-show="!mini" :isChannel="true" />
                    <ChannelsContextMenu/>
                  </div>
                </v-list-item-action>
              </v-subheader>
              <ChannelsList/>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>

          <v-divider></v-divider>

          <v-expansion-panels focusable v-model="show.groups" accordion>
            <v-expansion-panel>
              <v-expansion-panel-header v-show="!mini">
                <v-badge
                  color="orange"
                  :value="unreadGroups"
                  offset-x="30"
                  offset-y="18"
                >
                  <span>{{ $t('chat.privateChannels') }}</span>
                  <span slot="badge"> {{ unreadGroups }} </span>
                </v-badge>
              </v-expansion-panel-header>
              <v-expansion-panel-content eager>
                <v-subheader>
                  <v-list-item-content style="margin: 0px !important;min-width: 90px !important;">
                    <v-list-item-title>
                      <span class="mx-2" v-show="!mini">{{ $tc('chat.conversation', paginationGroups.total, { count: paginationGroups.total }) }}</span>
                    </v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-action style="margin: 0px !important;">
                    <div class="d-flex justify-center">
                      <Search v-show="!mini" :isGroup="true" />
                      <GroupsContextMenu/>
                    </div>
                  </v-list-item-action>
                </v-subheader>
                <GroupsList/>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>

          <v-divider></v-divider>

          <v-expansion-panels focusable v-model="show.dm" accordion>
            <v-expansion-panel>
              <v-expansion-panel-header v-show="!mini">
                <v-badge
                  color="orange"
                  :value="unreadDm"
                  offset-x="30"
                  offset-y="18"
                >
                  <span>{{ $t('chat.directMessages') }}</span>
                  <span slot="badge"> {{ unreadDm }} </span>
                </v-badge>
              </v-expansion-panel-header>
              <v-expansion-panel-content eager>
                <v-subheader>
                  <v-list-item-content style="margin: 0px !important;min-width: 90px !important;">
                    <v-list-item-title>
                      <span v-show="!mini">{{ $tc('chat.conversation', paginationDm.total, { count: paginationDm.total }) }}</span>
                    </v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-action style="margin: 0px !important;">
                    <div class="d-flex justify-center">
                      <Search v-show="!mini" :isDm="true" />
                      <DmContextMenu/>
                    </div>
                  </v-list-item-action>
                </v-subheader>
                  <DirectMessagesList/>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>

          <v-divider></v-divider>

          <v-expansion-panels focusable v-show="smsDids.length > 0" v-model="show.sms" accordion>
            <v-expansion-panel>
              <v-expansion-panel-header v-show="!mini">
                <v-badge
                  color="orange"
                  :value="unreadSMS"
                  offset-x="30"
                  offset-y="18"
                >
                  <span>SMS</span>
                  <span slot="badge"> {{ unreadSMS }} </span>
                </v-badge>
              </v-expansion-panel-header>
              <v-expansion-panel-content eager>
                <v-subheader>
                <v-list-item-content style="padding: 0px !important;">
                    <v-list-item-title>
                      <span v-show="!mini">{{ $tc('chat.conversation', paginationSms.total, { count: paginationSms.total }) }}</span>
                    </v-list-item-title>
                </v-list-item-content>
                <v-list-item-action style="margin: 0px !important;">
                  <div class="d-flex justify-center">
                    <Search v-show="!mini && smsDids.length > 0" :isSms="true" />
                    <SmsContextMenu/>
                  </div>
                </v-list-item-action>
              </v-subheader>
              <SmsList/>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-card>
    </v-navigation-drawer>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import DirectMessagesList from './drawer/direct_messages_list'
import SmsList from './drawer/sms_list'
import ChannelsList from './drawer/channels_list'
import GroupsList from './drawer/groups_list'
import SmsContextMenu from '@/components/chat/drawer/direct_chats/sms_context_menu'
import DmContextMenu from '@/components/chat/drawer/direct_chats/dm_context_menu'
import ChannelsContextMenu from '@/components/chat/drawer/channels/context_menu'
import GroupsContextMenu from '@/components/chat/drawer/groups/context_menu'
import StatusAvatar from '@/components/buddies/status_avatar'
import Search from '@/components/chat/drawer/search'
import ChatLocalStorage from '@/api/chat'

export default {
  name: 'chat-navdrawer',
  data () {
    return {
      showNewConversationButton: false,
      countDown: 1,
      mini: false,
      nav: true,
      show: {
        sms: true,
        channels: true,
        groups: true,
        dm: true
      }
    }
  },
  props: {
    drawer: { type: Boolean, default: true },
    singleRoom: { type: Boolean, default: true }
  },
  created () {
    this.getSmsDids()
    const menuVisibility = ChatLocalStorage.menuVisibility()
    if (menuVisibility) {
      this.show = menuVisibility
    }
  },
  components: {
    DirectMessagesList,
    ChannelsList,
    GroupsList,
    SmsList,
    StatusAvatar,
    SmsContextMenu,
    Search,
    DmContextMenu,
    ChannelsContextMenu,
    GroupsContextMenu
  },
  computed: {
    ...mapGetters({
      chatUser: 'chat/authenticatedRocketChatUser',
      users: 'users/list',
      buddies: 'users/buddies',
      chatsWrite: 'permissions/chatsWrite',
      smsDids: 'chat/smsDids',
      presences: 'chat/presences',
      paginationSms: 'chat/paginationSms',
      paginationDm: 'chat/paginationDm',
      paginationChannels: 'chat/paginationChannels',
      paginationGroups: 'chat/paginationGroups',
      directConversations: 'chat/directConversations',
      smsConversations: 'chat/smsConversations',
      groups: 'chat/groups',
      channels: 'chat/channels'
    }),

    roomId () {
      return this.$route?.params?.roomId || null
    },

    getUser () {
      const buddyUser = this.buddies.find((user) => user.exten === this.chatUser?.extension)
      if (buddyUser) {
        return buddyUser
      }
      return this.users.find((user) => user.exten === this.chatUser?.extension)
    },

    unreadChannels () {
      return this.channels?.reduce((acc, message) => acc + message.unread, 0)
    },

    unreadGroups () {
      return this.groups?.reduce((acc, message) => acc + message.unread, 0)
    },

    unreadSMS () {
      return this.smsConversations?.reduce((acc, message) => acc + message.unread, 0)
    },

    unreadDm () {
      return this.directConversations?.reduce((acc, message) => acc + message.unread, 0)
    }
  },

  watch: {
    show: {
      handler (value) {
        ChatLocalStorage.setMenuVisibility(value)
      },
      deep: true
    },
    singleRoom: {
      handler (value) {
        this.$emit('set-single-room', value)
      }
    }
  },

  methods: {
    ...mapActions({
      openDialog: 'chat/openDialog',
      getSmsDids: 'chat/getSmsDids'
    }),

    startConversation () {
      if (this.$vuetify.breakpoint.mobile) {
        this.drawer = false
      }
      this.openDialog()
    },

    expandMenu (menu) {
      this.show[menu] = !this.show[menu]
    },

    getExpandIcon (value) {
      if (value) {
        return 'mdi-chevron-down'
      } else {
        return 'mdi-chevron-up'
      }
    }
  }
}
</script>

<style scoped>
  .v-expansion-panel-content::v-deep .v-expansion-panel-content__wrap {
    padding: 0 !important;
  }
</style>
